import React from "react";

function WorkCard({ data }) {
  return (
    <div className="workCard">
      <div className="workCard__img__container">
        <img src={data.image} alt="card" />
      </div>
      <div className="workCard__body">
        <div className="workCard__body__content">
          <h3>{data.title}</h3>
          {/* <h4>{data.subTitle}</h4>
          <p>{data.description}</p> */}
        </div>
      </div>
      {/* <button onClick={() => window.open(data.link)} >Know More</button> */}
    </div>
  );
}

export default WorkCard;
